const fontFamily = 'ui-monospace, monospace';
const fontSize = 14;
export const styles = {
    statsForNerds: {
        position: 'absolute',
        top: 16,
        right: 16,
        zIndex: 1000,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: 10,
        borderRadius: 5,
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
    },
    entry: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        marginBottom: 8,
    },
    entryLabel: {
        color: '#fff',
        fontFamily,
        fontSize,
        fontWeight: 'bold',
        marginRight: 20,
    },
    entryValue: {
        fontFamily,
        fontSize,
        color: '#fff',
        maxWidth: 400,
    },
};
